import { render, staticRenderFns } from "./NoteSelectPopup.vue?vue&type=template&id=37d20654&"
import script from "./NoteSelectPopup.vue?vue&type=script&lang=js&"
export * from "./NoteSelectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d20654')) {
      api.createRecord('37d20654', component.options)
    } else {
      api.reload('37d20654', component.options)
    }
    module.hot.accept("./NoteSelectPopup.vue?vue&type=template&id=37d20654&", function () {
      api.rerender('37d20654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/popup/NoteSelectPopup.vue"
export default component.exports